module.exports = __webpack_public_path__ + "static/img/r4.da4c310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/r4.png
// module id = tr0V
// module chunks = 1